import config from './config';
import { openMiddlePage } from './utils/helpers';

function launchApp(customUrl, altUrl, cb) {
  let heartbeat; let timer; let iframeTimer;

  launchAppOrDownload();

  function launchAppOrDownload() {
    heartbeat = setInterval(intervalHeartbeat, 200);

    const ua = navigator.userAgent;
    // 1. For iOS 9+ devices, iframe approach will not work.
    // 2. ios手机管家用webkit方式会弹窗报错
    if (/(iPhone|iPad|iPod).*OS\s[9,10]/i.test(ua) && !/mqqsecure/i.test(ua)) {
      tryWebkitApproach();
    } else {
      tryIframeApproach();
    }
  }

  function tryIframeApproach() {
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'width:1px;height:1px;position:fixed;top:0;left:0;opacity:0;visibility:hidden;';
    iframe.setAttribute('data-html2canvas-ignore', '');
    iframe.src = customUrl;

    const startTime = Date.now();
    iframeTimer = setTimeout(() => {
      const delta = Date.now() - startTime;
      let isInstalled = true;
      if (delta < 3500) {
        isInstalled = false;
        cb(isInstalled);
      } else {
        cb(isInstalled);
      }
    }, 3000);

    document.body.appendChild(iframe);
  }

  function tryWebkitApproach() {
    document.location = customUrl;

    const startTime = Date.now();
    timer = setTimeout(() => {
      const delta = Date.now() - startTime;
      let isInstalled = true;
      if (delta < 3500) {
        isInstalled = false;
        cb(isInstalled);
      } else {
        cb(isInstalled);
      }
    }, 3000);
  }

  function clearTimers() {
    clearInterval(heartbeat);
    clearTimeout(timer);
    clearTimeout(iframeTimer);
  }

  function intervalHeartbeat() {
    const hidden = document.webkitHidden || document.hidden;
    if (hidden) {
      clearTimers();
    }
  }
}

export const canGetInstallState = false;

export function ready() {
  return true;
}

export async function getInstallState() {
  throw new Error('cannot get install state');
}

export async function launch(schemeUrl) {
  return new Promise((resolve) => {
    // console.log(
    //   "当前环境不支持检查是否安装APP，此次调用将尝试拉取APP，如果失败将跳转到下载链接"
    // );
    launchApp(schemeUrl, config.download, resolve);
  });
}

export async function download(conf = config) {
  const isOpenAppPage = openMiddlePage();
  // 只有 openapp 中间页才拉起下载
  if (!isOpenAppPage) return;

  window.location.href = conf.download;
}

export default {
  canGetInstallState,
  ready,
  getInstallState,
  launch,
  download,
};
